import React, {useState,useEffect, useCallback} from 'react';
import { useNavigate } from "react-router-dom";
import authService from 'core/services/authService';
import { ROUTES } from 'core/utils/constants';

const defaults = {
  isUserLoggedIn: false,
  authToken:  null,
  permissions: [],
  userId: null,
  data: {}
};

const AuthContext = React.createContext({...defaults});

const AuthContextProvider = (props) => {

  const [context, setContext] = useState({...defaults, authToken: authService.getAuthorizationToken(), userId: authService.getUserIdFromBrowser()});
  let navigate = useNavigate();

  useEffect(() => {
    // context?.authToken && authService.setAuthToken(context.authToken);
    authService.userRoles = context?.permissions || [];
  }, [context?.permissions]);

  const updateAuthContext = useCallback((contextValues = {}) => {
    const data = {
      ...context,
      // authToken: contextValues.accessToken,
      ...contextValues
    };
    setContext(data);
  }, [context]);

  const resetContext = useCallback(() => {
    setContext({...defaults});
  }, []);

  const userSignout = useCallback(() => {
    authService.clearData();
    resetContext();
    navigate(ROUTES.LOGIN, {replace: true});
  }, [navigate, resetContext]);

  return (
    <AuthContext.Provider value={{...context, updateAuthContext, resetContext, userSignout}}>
      {props.children}
    </AuthContext.Provider>
  );
}
 
export default AuthContextProvider;
export { AuthContext };
